module.exports = __webpack_public_path__ + "img/Flag_of_Guam.65c9513a.svg";